import React, { useState, useEffect } from 'react';

const BackToTop = () => {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    const toggleVisibility = () => {
      // Show button when page is scrolled down past the typical hero/TOC threshold
      if (window.scrollY > 500) {
        setIsVisible(true);
      } else {
        setIsVisible(false);
      }
    };

    window.addEventListener('scroll', toggleVisibility);
    return () => window.removeEventListener('scroll', toggleVisibility);
  }, []);

  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: 'smooth'
    });
  };

  if (!isVisible) return null;

  return (
    <button
      onClick={scrollToTop}
      className="fixed bottom-8 right-8 bg-slate-800/80 hover:bg-slate-700 backdrop-blur text-slate-300 hover:text-white border border-slate-600/50 rounded-full px-5 py-3 shadow-2xl transition-all z-50 text-sm font-bold flex items-center gap-2 group"
      aria-label="Back to top"
    >
      <span className="group-hover:-translate-y-1 transition-transform">↑</span> 
      Back to Contents
    </button>
  );
};

export default BackToTop;
